import { IBreadCrumbs } from '../../interfaces/common/IBreadcrumbs';

export class BreadCrumbs implements IBreadCrumbs {
    name!: string;
    url!: string;
    active!: boolean;
}
